// extracted by mini-css-extract-plugin
module.exports = {"TermsOfUseAndPrivacyPolicy":"TermsOfUseAndPrivacyPolicy_TermsOfUseAndPrivacyPolicy__3cEKq"};